import {ChangeDetectionStrategy, Component} from '@angular/core';
import {FieldWrapper} from '@ngx-formly/core';

/** Formly-wrapper: иконка-info у поля → nb-popover с HTML из `templateOptions.help`. */
@Component({
  selector: 'app-seo-field-help',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="seo-fh">
      @if (help) {
        <button type="button" class="seo-fh__icon" i18n-aria-label="@@SettingDescriptionAria" aria-label="Описание настройки"
                [nbPopover]="helpTpl" nbPopoverTrigger="hover" nbPopoverPlacement="left">
          <tui-icon icon="@tui.info"/>
        </button>
      }
      <ng-container #fieldComponent/>
    </div>
    <ng-template #helpTpl>
      <div class="seo-fh__pop">
        <div [innerHTML]="help"></div>
      </div>
    </ng-template>
  `,
  styles: [`
    .seo-fh {
      position: relative;
      &:hover .seo-fh__icon {
        display: inline-flex;
      }
    }

    .seo-fh__icon {
      position: absolute;
      top: -2px;
      right: 10%;
      z-index: 1;
      display: none;
      align-items: center;
      justify-content: center;
      padding: 0;
      border: none;
      background: transparent;
      cursor: pointer;
      color: var(--text-hint-color);
      transition: color .15s;
    }

    .seo-fh__icon tui-icon {
      font-size: 26px;
      width: 26px;
      height: 26px;
    }

    .seo-fh__icon:hover {
      color: var(--color-primary-500);
    }

    .seo-fh__pop {
      max-width: 340px;
      padding: 10px 14px;
      font-size: 14px;
      line-height: 1.55;
    }

    .seo-fh__pop :is(ul, ol) {
      margin: 4px 0;
      padding-left: 18px;
    }

    .seo-fh__pop code {
      background: var(--background-basic-color-3);
      padding: 1px 4px;
      border-radius: 3px;
      font-size: 13px;
    }
  `],
})
export class SeoFieldHelpWrapperComponent extends FieldWrapper {
  get help(): string | undefined {
    return (this.props as {help?: string}).help;
  }
}
